////////////////
// Analytics //
//////////////

import GameAnalytics from "not-game-analytics"

GameAnalytics.isReporting = true

GameAnalytics.BUILD_VERSION = "v0.24.3"

import app from "@frog/source/data/app.js"
import games from "@frog/source/data/games"
const game = games[app.defaultGameSlug]
GameAnalytics.GAME_KEY = game?.analytics?.gameKey
GameAnalytics.SECRET_KEY = game?.analytics?.secretKey

console.log("Initializing analytics for " + game?.slug)

window.addEventListener("error", (error) => {
    GameAnalytics.reportError(error)
})

// Mocks
GameAnalytics._ = {
    "reportStageStart": function() {},
    "reportStageSuccess": function() {},
    "reportStageFailure": function() {},
}
